export var FailureReason;
(function (FailureReason) {
    FailureReason["TOO_LARGE"] = "TOO_LARGE";
    FailureReason["INVALID_FORMAT"] = "INVALID_FORMAT";
    FailureReason["TOO_SHORT"] = "TOO_SHORT";
    FailureReason["TOO_LONG"] = "TOO_LONG";
    FailureReason["PASSWORD_PROTECTED"] = "PASSWORD_PROTECTED";
    FailureReason["INSUFFICIENT_LIVE_MINUTES"] = "INSUFFICIENT_LIVE_MINUTES";
    FailureReason["NO_SPEECH_DETECTED"] = "NO_SPEECH_DETECTED";
})(FailureReason || (FailureReason = {}));
